import React from "react";
import { Input, Segmented, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";

// The strip above a booking section's task tree. Material, Mechanical and
// Mucking & PRW list civil-completed TASKS rather than a day: by default only
// the ones still owed something, with "All civil-done" for extra or corrective
// entries, and a search across task, code and activity.
const CivilTaskFilterBar: React.FC<{
  pendingOnly: boolean;
  onPendingOnlyChange: (value: boolean) => void;
  search: string;
  onSearchChange: (value: string) => void;
  pendingCount: number;
  allCount: number;
  what: string; // "material", "machine hours", "Mucking / PRW"
}> = ({ pendingOnly, onPendingOnlyChange, search, onSearchChange, pendingCount, allCount, what }) => (
  <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 8 }}>
    <Tooltip title={`Civil work is done on these tasks; book the ${what} used for it here — it is counted against that work`}>
      <Segmented
        value={pendingOnly ? "pending" : "all"}
        onChange={(v) => onPendingOnlyChange(v === "pending")}
        options={[
          { label: `Pending ${what} (${pendingCount})`, value: "pending" },
          { label: `All civil-done (${allCount})`, value: "all" },
        ]}
      />
    </Tooltip>
    <Input
      allowClear
      prefix={<SearchOutlined style={{ color: "#8094ae" }} />}
      placeholder="Find a task, code or activity"
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      style={{ width: 280 }}
    />
  </div>
);

export default CivilTaskFilterBar;
